import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { resourceExplorerChartDataSelector } from "./resourceExplorerChartDataSelector";
import { aggregateHighChartDataSeriesMap } from "@/storybook/c8r-highcharts/common/utils/helpers/aggregateHighChartDataSeriesMap";

export const resourceExplorerChartDataSeriesMapSelector =
  createDraftSafeSelector([resourceExplorerChartDataSelector], (chartData) => {
    return aggregateHighChartDataSeriesMap(chartData);
  });
